/* eslint-disable */
import { FuseNavigationItem } from "@fuse/components/navigation";

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: "ave",
    title: "Módulos",
    subtitle: "",
    type: "group",
    icon: "heroicons_outline:document",
    children: [
      {
        id: "ave.masters",
        title: "Maestros",
        type: "collapsable",
        icon: "heroicons_outline:cog-6-tooth",
        children: [
          {
            id: "ave.masters.configuration",
            title: "Estructura Org.",
            type: "collapsable",
            //icon: "heroicons_outline:cog-6-tooth",
            children: [
              /*{
                id: "ave.masters.business-partner.tenant",
                title: "Tenants",
                type: "basic",
                link: "/master/configuration/tenant",
              },*/
              {
                id: "ave.masters.business-partner.company",
                title: "Compañías",
                type: "basic",
                link: "/master/configuration/company",
              },
              {
                id: "ave.masters.business-partner.sales-organization",
                title: "Org. de Ventas",
                type: "basic",
                link: "/master/configuration/sales-organization",
              },
              {
                id: "ave.masters.business-partner.channel",
                title: "Canales de Distrib.",
                type: "basic",
                link: "/master/configuration/channel",
              },
              {
                id: "ave.masters.business-partner.distribution-chain",
                title: "Cadenas de Distrib.",
                type: "basic",
                link: "/master/configuration/distribution-chain",
              },
              {
                id: "ave.masters.business-partner.division",
                title: "Divisiones",
                type: "basic",
                link: "/master/configuration/division",
              },
              {
                id: "ave.masters.business-partner.office-group",
                title: "G. Oficinas de Venta",
                type: "basic",
                link: "/master/configuration/office-group",
              },
              {
                id: "ave.masters.business-partner.sales-office",
                title: "Oficinas de Venta",
                type: "basic",
                link: "/master/configuration/sales-office",
              },
              {
                id: "ave.masters.business-partner.plant",
                title: "Plantas",
                type: "basic",
                link: "/master/configuration/plant",
              },
              {
                id: "ave.masters.business-partner.warehouse",
                title: "Almacenes",
                type: "basic",
                link: "/master/configuration/warehouse",
              },
            ],
          },
          {
            id: "ave.masters.locations",
            title: "Ubicaciones",
            type: "collapsable",
            //icon: "heroicons_outline:map-pin",
            children: [
              {
                id: "ave.masters.locations.location-one",
                title: "Países",
                type: "basic",
                link: "/master/locations/location-one",
              },
              {
                id: "ave.masters.locations.location-two",
                title: "Departamentos",
                type: "basic",
                link: "/master/locations/location-two",
              },
              {
                id: "ave.masters.locations.location-three",
                title: "Ciudades",
                type: "basic",
                link: "/master/locations/location-three",
              },
              {
                id: "ave.masters.locations.location-four",
                title: "Colonias",
                type: "basic",
                link: "/master/locations/location-four",
              },
              /*{
                id: "ave.masters.location.location-five",
                title: "Ubicacion 5",
                type: "basic",
                link: "/master/locations/location-five",
              },
              {
                id: "ave.masters.location.location-six",
                title: "Ubicacion 6",
                type: "basic",
                link: "/master/locations/location-six",
              },*/
            ],
          },
          {
            id: "ave.masters.materials",
            title: "Materiales",
            type: "collapsable",
            //icon: "heroicons_outline:squares-2x2",
            children: [
              {
                id: "ave.masters.materials.material",
                title: "Materiales",
                type: "basic",
                link: "/master/materials/material",
              },
              {
                id: "ave.masters.materials.list-material",
                title: "Lista de Materiales",
                type: "basic",
                link: "/master/materials/list-material",
              },
              {
                id: "ave.masters.materials.material-group",
                title: "Grupos",
                type: "basic",
                link: "/master/materials/material-group",
              },
              {
                id: "ave.masters.materials.material-brand",
                title: "Marcas",
                type: "basic",
                link: "/master/materials/material-brand",
              },
              {
                id: "ave.masters.materials.units-of-measurement",
                title: "Unidades de Medida",
                type: "basic",
                link: "/master/masters/units-of-measurement",
              },
            ],
          },
          {
            id: "ave.masters.business-partner",
            title: "Socios de Negocio",
            type: "collapsable",
            //icon: "heroicons_outline:users",
            children: [
              {
                id: "ave.masters.business-partner.business-partner",
                title: "Socios de Negocio",
                type: "basic",
                link: "/master/business-partner/business-partner",
              },
              {
                id: "ave.masters.business-partner.business-partner-news",
                title: "Nuevos Clientes",
                type: "basic",
                link: "/master/business-partner/business-partner-news",
              },
              {
                id: "ave.masters.business-partner.business-partner-type",
                title: "Tipos",
                type: "basic",
                link: "/master/business-partner/business-partner-type",
              },
              {
                id: "ave.masters.business-partner.business-partner-function",
                title: "Fn. de Interlocutor",
                type: "basic",
                link: "/master/business-partner/business-partner-function",
              },
              {
                id: "ave.masters.business-partner.business-partner-contact",
                title: "Fn. de Contacto",
                type: "basic",
                link: "/master/business-partner/business-partner-contact",
              },
              {
                id: "ave.masters.business-partner.business-partner-group",
                title: "Grupos",
                type: "basic",
                link: "/master/business-partner/business-partner-group",
              },
              {
                id: "ave.masters.business-partner.business-partner-subgroup",
                title: "Subgrupos",
                type: "basic",
                link: "/master/business-partner/business-partner-subgroup",
              },
              {
                id: "ave.masters.business-partner.pending-addresses",
                title: "Direcciones Pendientes",
                type: "basic",
                link: "/master/business-partner/pending-addresses",
              },
              {
                id: "ave.masters.business-partner.payment-masters",
                title: "Pagos",
                type: "collapsable",
                //icon: "heroicons_outline:banknotes",
                children: [
                  {
                    id: "ave.masters.business-partner.payment-masters.payment-condition",
                    title: "Condiciones de Pago",
                    type: "basic",
                    link: "/master/masters/payment-conditions",
                  },
                  {
                    id: "ave.masters.masters.payment-method",
                    title: "Métodos de pago",
                    type: "basic",
                    link: "/master/payment-masters/payment-methods",
                  },
                  {
                    id: "ave.masters.business-partner.payment-masters.payment-types",
                    title: "Tipos de Pago",
                    type: "basic",
                    link: "/master/payment-masters/payment-types",
                  },
                  {
                    id: "ave.masters.business-partner.payment-masters.banks",
                    title: "Bancos",
                    type: "basic",
                    link: "/master/payment-masters/banks",
                  },
                ],
              },
            ],
          },
          {
            id: "ave.masters.routing",
            title: "Rutas",
            type: "collapsable",
            //icon: "heroicons_outline:map",
            children: [
              {
                id: "ave.masters.routing.route",
                title: "Territorios",
                type: "basic",
                link: "/master/routing/route",
              },
              {
                id: "ave.masters.routing.route-area",
                title: "Áreas de Rutas",
                type: "basic",
                link: "/master/routing/route-area",
              },
              {
                id: "ave.masters.routing.route-group",
                title: "Grupos de Rutas",
                type: "basic",
                link: "/master/routing/route-group",
              },
              {
                id: "ave.masters.routing.sub-route",
                title: "Rutas",
                type: "basic",
                link: "/master/routing/sub-route",
              },
              {
                id: "ave.masters.routing.sub-route-activity",
                title: "Act. de Rutas",
                type: "basic",
                link: "/master/routing/sub-route-activity",
              },
              {
                id: "ave.masters.routing.sub-route-function",
                title: "Fn. de Rutas",
                type: "basic",
                link: "/master/routing/sub-route-function",
              },
              {
                id: "ave.masters.routing.customer-route-frequency-report",
                title: "Cliente y Frecuencia de Rutas",
                type: "basic",
                link: "/master/routing/customer-route-frequency-report",
              },
              {
                id: "ave.masters.routing.customer-territories-report",
                title: "Clientes y territorios",
                type: "basic",
                link: "/master/routing/customer-territories-report",
              },
              {
                id: "ave.masters.routing.routes-territories-report",
                title: "Rutas de territorios",
                type: "basic",
                link: "/master/routing/routes-territories-report",
              },              
              {
                id: "ave.masters.routing.liquidation-report",
                title: "Liquidaciones",
                type: "basic",
                link: "/master/routing/liquidation-report",
              }
            ],
          },
          {
            id: "ave.masters.trade-policies",
            title: "Políticas Comerciales",
            type: "collapsable",
            //icon: "heroicons_outline:map",
            children: [
              {
                id: "ave.masters.trade-policies.price-list",
                title: "Listas",
                type: "basic",
                link: "/master/masters/price-list",
              },
              {
                id: "ave.masters.trade-policies.strategy-list",
                title: "Cnf. Listas",
                type: "basic",
                link: "/master/masters/strategy-list",
              },
            ],
          },
          {
            id: "ave.masters.masters",
            title: "Funciones Básicas",
            type: "collapsable",
            //icon: "heroicons_outline:cog-6-tooth",
            children: [
              {
                id: "ave.masters.masters.expedition-condition",
                title: "Condiciones de Exp.",
                type: "basic",
                link: "/master/masters/expedition-condition",
              },
              {
                id: "ave.masters.masters.change-condition",
                title: "Condic. de Cambio",
                type: "basic",
                link: "/master/masters/change-condition",
              },
              {
                id: "ave.masters.masters.reason-for-visit",
                title: "Mtvo. de Visita",
                type: "basic",
                link: "/master/masters/reasons-for-visit",
              },
              {
                id: "ave.masters.masters.reason-for-rejection",
                title: "Motivos de Rechazo",
                type: "basic",
                link: "/master/masters/reasons-for-rejection",
              },
              {
                id: "ave.masters.masters.reason-for-block",
                title: "Mtvo. de Bloqueo SN",
                type: "basic",
                link: "/master/masters/reasons-for-block",
              },
              {
                id: "ave.masters.masters.bad-condition-motives",
                title: "Motivos de Mal Estado",
                type: "basic",
                link: "/master/masters/bad-condition-motives",
              },
              {
                id: "ave.masters.masters.requirement",
                title: "Requisitos",
                type: "basic",
                link: "/master/masters/requirement",
              },
              {
                id: "ave.masters.masters.rejection-type",
                title: "Tipos de Rechazo",
                type: "basic",
                link: "/master/masters/rejection-type",
              },
              {
                id: "ave.masters.masters.identity-document-type",
                title: "Tipos de Documento de Identidad",
                type: "basic",
                link: "/master/masters/identity-document-type",
              },
              {
                id: "ave.masters.masters.address-type",
                title: "Tipos de Dirección",
                type: "basic",
                link: "/master/common/address-type",
              },
              {
                id: "ave.masters.masters.phone-type",
                title: "Tipos de Teléfono",
                type: "basic",
                link: "/master/common/phone-type",
              },
              {
                id: "ave.masters.masters.social-type",
                title: "Redes Sociales",
                type: "basic",
                link: "/master/common/social-media-type",
              },
            ],
          },
          // {

          //   id:"ave.reasons",
          //   title:"Motivos",
          //   type:"collapsable",
          //   children:[
          //     {
          //       id:"ave.reasons.rejection-type",
          //       title:"Tipos de Rechazo",
          //       type:"basic",
          //       link:"/master/reasons/rejection-type",
          //     },
          //   ],
          // },
          {
            id: "ave.document",
            title: "Documentos",
            type: "collapsable",
            // icon: "heroicons_outline:document-duplicate",
            children: [
              {
                id: "ave.document.type",
                title: "Tipos",
                type: "basic",
                link: "/master/document/document-type",
              },
              {
                id: "ave.document.class",
                title: "Clases",
                type: "basic",
                link: "/master/document/document-class",
              },
              {
                id: "ave.document.emission",
                title: "Punto de Emisión",
                type: "basic",
                link: "/master/document/emission-point",
              },
              {
                id: "ave.document.range",
                title: "Rangos",
                type: "basic",
                link: "/master/document/document-range",
              },
            ],
          },
          {
            id: "ave.transport",
            title: "Transporte",
            type: "collapsable",
            // icon: "heroicons_outline:transport-duplicate",
            children: [
              {
                id: "ave.transport.type",
                title: "Tipos",
                type: "basic",
                link: "/master/transport/transport-type",
              },
              {
                id: "ave.transport.class",
                title: "Vehículo",
                type: "basic",
                link: "/master/transport/transport-vehicle",
              },
            ],
          },
        ],
      },

      {
        id: "ave.assistant",
        title: "Asistente",
        type: "collapsable",
        icon: "heroicons_outline:calendar-days",
        children: [
          {
            id: "ave.assistant.sales",
            title: "Ventas",
            type: "collapsable",
            //icon: "heroicons_outline:shopping-cart",
            children: [
              {
                id: "ave.assistant.sales.distribution",
                title: "Distribución",
                type: "basic",
                link: "/assistant/sales/distribution",
              },
              {
                id: "ave.assistant.sales.suggerted-sales",
                title: "Sugerido de ventas",
                type: "basic",
                link: "/assistant/sales/suggested-sales",
              },
            ],
          },
          {
            id: "ave.assistant.delivery",
            title: "Entrega",
            type: "collapsable",
            //icon: "heroicons_outline:shopping-cart",
            children: [
              {
                id: "ave.assistant.delivery.loads",
                title: "Carga",
                type: "basic",
                link: "/assistant/delivery/loads",
              },
            ],
          },
          {
            id: "ave.assistant.routes",
            title: "Rutas",
            type: "collapsable",
            //icon: "heroicons_outline:shopping-cart",
            children: [
              {
                id: "ave.assistant.routes.optimization",
                title: "Optimización",
                type: "basic",
                link: "/assistant/sales/other",
              },
            ],
          },
        ],
      },

      {
        id: "ave.process",
        title: "Procesos",
        type: "collapsable",
        icon: "heroicons_outline:clipboard-document-check",
        children: [
          {
            id: "ave.process.sales",
            title: "Ventas",
            type: "collapsable",
            //icon: "heroicons_outline:shopping-cart",
            children: [
              {
                id: "ave.process.sales",
                title: "Generación",
                type: "collapsable",
                //icon: "heroicons_outline:banknotes",
                children: [
                  /*{
                    id: "ave.process.sales.orders-creation",
                    title: "Generación OLD de Pedidos",
                    type: "basic",
                    link: "/master/sales/orders-creation",
                  },*/
                  {
                    id: "ave.process.sales.order-generate",
                    title: "Pedidos",
                    type: "basic",
                    link: "/master/sales/order-generate",
                  },
                  {
                    id: "ave.process.sales.quotation-generate",
                    title: "Cotización",
                    type: "basic",
                    link: "/master/sales/quotation-generate",
                  },
                ],
              },
              {
                id: "ave.process.sales",
                title: "Listado",
                type: "collapsable",
                //icon: "heroicons_outline:banknotes",
                children: [
                  {
                    id: "ave.process.sales.quotation-list",
                    title: "Cotizaciones",
                    type: "basic",
                    link: "/master/sales/quotation-list",
                  },
                  {
                    id: "ave.process.sales.orders-list",
                    title: "Pedidos",
                    type: "basic",
                    link: "/master/sales/orders-list",
                  },
                  {
                    id: "ave.process.sales.load-documents-list",
                    title: "Documentos de Carga",
                    type: "basic",
                    link: "/master/sales/load-documents-list",
                  },
                  {
                    id: "ave.process.sales.delivery-list",
                    title: "Entregas",
                    type: "basic",
                    link: "/master/sales/delivery-list",
                  },
                  {
                    id: "ave.process.sales.invoice-list",
                    title: "Facturas",
                    type: "basic",
                    link: "/master/sales/invoice-list",
                  },
                  {
                    id: "ave.process.sales.request-change-item-list",
                    title: "Solicitud de Cambio",
                    type: "basic",
                    link: "/master/sales/request-change-item-list",
                  },
                  {
                    id: "ave.process.sales.change-item-list",
                    title: "Cambios",
                    type: "basic",
                    link: "/master/sales/change-item-list",
                  },
                  {
                    id: "ave.process.sales.request-return-list",
                    title: "Solicitud de Devolución",
                    type: "basic",
                    link: "/master/sales/request-return-list",
                  },
                  {
                    id: "ave.process.sales.return-list",
                    title: "Devoluciones",
                    type: "basic",
                    link: "/master/sales/return-list",
                  },
                  {
                    id: "ave.process.sales.trip",
                    title: "Viajes",
                    type: "basic",
                    link: "/master/sales/trip",
                  },
                  {
                    id: "ave.process.sales.geolocation",
                    title: "Geolocalización Pendiente",
                    type: "basic",
                    link: "/master/sales/geolocation-pending",
                  },
                ],
              },
            ],
          },
          {
            id: "ave.process.collections",
            title: "Cobranza",
            type: "collapsable",
            permission: ['ALL', 'FICO'],
            children: [
              {
                id: "ave.process.collections.open-items",
                title: "Partidas Abiertas",
                type: "basic",
                permission: ['ALL', 'FICO'],
                link: "/master/collections/open-items",
              },
              {
                id: "ave.process.collections.payment-management",
                title: "Pagos",
                type: "basic",
                permission: ['ALL', 'FICO'],
                link: "/master/collections/payment-management",
              },
            ],
          },
          {
            id: "ave.process.request",
            title: "Solicitudes",
            type: "collapsable",
            //icon: "heroicons_outline:shopping-cart",
            children: [
              {
                id: "ave.process.request.seller-order",
                title: "Pedido Vendedor",
                type: "basic",
                link: "/master/request/seller-order",
              },
            ],
          },
        ],
      },

      {
        id: "ave.reports",
        title: "Reportes",
        type: "collapsable",
        icon: "heroicons_outline:clipboard-document-list",
        children: [
          {
            id: "ave.reports.stock-break",
            title: "Quiebre de Inventario",
            type: "basic",
            link: "/reports/stock-break",
          },
          {
            id: "ave.reports.lost-sale",
            title: "Venta Perdida",
            type: "basic",
            link: "/reports/lost-sale",
          },
          {
            id: "ave.reports.visits.visit-report",
            title: "Visitas",
            type: "basic",
            link: "/reports/visits/visit-report",
          },
          {
            id: "ave.reports.historic.total-necessity",
            title: "Necesidad Total",
            type: "basic",
            link: "/reports/historic/total-necessity",
          },
          // {
          //   id: "ave.reports.visits",
          //   title: "Visitas",
          //   type: "collapsable",
          //   children: [
          //     {
          //       id: "ave.reports.visits.visit-control",
          //       title: "Control de Visitas",
          //       type: "basic",
          //       link: "/reports/visits/visit-control",
          //     },
          //     {
          //       id: "ave.reports.visits.visit-report",
          //       title: "Reporte de Visitas",
          //       type: "basic",
          //       link: "/reports/visits/visit-report",
          //     },
          //     {
          //       id: "ave.reports.visits.census-quality",
          //       title: "Calidad de Censos",
          //       type: "basic",
          //       link: "/reports/visits/census-quality",
          //     },
          //   ],
          // },
          {
            id: "ave.reports.historic",
            title: "Históricos",
            type: "collapsable",
            children: [
              {
                id: "ave.reports.historic.change-product",
                title: "Cambios de Productos",
                type: "basic",
                link: "/reports/historic/change-product",
              },
              {
                id: "ave.reports.historic.return-product",
                title: "Devoluciones",
                type: "basic",
                link: "/reports/historic/return-product",
              },
              {
                id: "ave.reports.historic.request-change",
                title: "Solicitud de Cambio",
                type: "basic",
                link: "/reports/historic/request-change",
              },
              {
                id: "ave.reports.historic.order-customer",
                title: "Pedidos Clientes",
                type: "basic",
                link: "/reports/historic/order-customer",
              },
              {
                id: "ave.reports.historic.order-seller",
                title: "Pedidos Vendedor",
                type: "basic",
                link: "/reports/historic/order-seller",
              },
                {
                id: "ave.reports.historic.order-invoice",
                title: "Facturas Clientes",
                type: "basic",
                link: "/reports/historic/order-invoice",
              },
              {
                id: "ave.reports.historic.attention-stock",
                title: "Stock",
                type: "basic",
                link: "/reports/historic/attention-stock",
              },
              {
                id: "ave.reports.historic.open-items",
                title: "Partidas Abiertas",
                type: "basic",
                permission: ['ALL', 'FICO'],
                link: "/reports/historic/open-items",
              },
              {
                id: "ave.reports.historic.order-payment",
                title: "Cobranza",
                type: "basic",
                permission: ['ALL', 'FICO'],
                link: "/reports/historic/order-payment",
              },
            ],
          },
          {
            id: "ave.reports.historic.proration",
            title: "Prorrateo",
            type: "basic",
            link: "/reports/historic/proration",
          },
        ],
      },

      {
        id: "ave.monitor",
        title: "Monitor",
        type: "basic",
        icon: "heroicons_outline:eye",
        link: "/monitor/principal-screen",
      },

      //    {
      //   id: "ave.dashboard",
      //   title: "Dashboard",
      //   type: "basic",
      //   icon: "heroicons_outline:chart-bar",
      //   link: "/dashboard/principal",
      // },

      {
        id: "ave.uploadFormat",
        title: "Formatos de Carga",
        type: "basic",
        icon: "heroicons_outline:arrow-up-tray",
        link: "/uploadFormat/format-upload",
      },
    ],
  },
  {
    id: "ave.synchronization",
    title: "Sincronización",
    type: "collapsable",
    icon: "heroicons_outline:arrow-path",
    children: [
      {
        id: "ave.synchronization.system-services",
        title: "Servicios de sincronización",
        type: "basic",
        link: "/synchronization/system-services",
      },
      {
        id: "ave.synchronization.system-latency",
        title: "Latencia",
        type: "basic",
        link: "/synchronization/system-latency",
      },
    ],
  },
  {
    id: "ave.notification",
    title: "Notificación",
    type: "collapsable",
    icon: "heroicons_outline:bell",
    children: [
      {
        id: "ave.notification.notification-member",
        title: "Miembros",
        type: "basic",
        link: "/notification/notification-member", 
      },
      {
        id: "ave.notification.notification-group",
        title: "Grupos",
        type: "basic",
        link: "/notification/notification-group", 
      },
      {
        id: "ave.notification.notification",
        title: "Notificaciones",
        type: "basic",
        link: "/notification/notification", 
      }
    ]
  },
//Activos
    {
    id: "ave.asset",
    title: "Activos",
    type: "collapsable",
    icon: "heroicons_outline:archive-box",
    children: [
      {
        id: "ave.asset.asset",
        title: "Activos",
        type: "basic",
        link: "/asset/asset", 
      },
      {
        id: "ave.asset.asset-group",
        title: "Grupos",
        type: "basic",
        link: "/asset/asset-group", 
      },
      {
        id: "ave.asset.asset-control",
        title: "Asignación",
        type: "basic",
        link: "/asset/asset-control", 
      }
    ]
  },

  {
    id: "system",
    title: "Sistema",
    subtitle: "",
    type: "group",
    icon: "heroicons_outline:document",
    children: [
      {
        id: "system.configurations",
        title: "Configuración",
        type: "collapsable",
        icon: "heroicons_outline:user",
        children: [
          {
            id: "system.configurations.users",
            title: "Usuarios",
            type: "basic",
            link: "/configurations/users",
          },
          {
            id: "system.configurations.external-keys",
            title: "Default Keys",
            type: "basic",
            link: "/configurations/external-keys",
          },
        ],
      },
    ],
  },
];

export const compactNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    title: "Example",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/example",
  },
];

export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    title: "Example",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/example",
  },
];

export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    title: "Example",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/example",
  },
];
